import { ReactNode } from "react";

type SUPPORTED_CONNECTORS =
  | "MetaMask"
  | "WalletConnect"
  | "AlgoSigner"
  | "Keplr"
  | "Zerion";

type ALGO_SIGNER = "TestNet" | "MainNet";

export interface FoundryProviderProps {
  children: ReactNode;
  supportedConnectors?: SUPPORTED_CONNECTORS[];
  AlgoSignerLedger?: ALGO_SIGNER;
}

export interface FoundryProviderState {
  connectors: string[];
  algoSignerLedger: string;
}

export interface FoundryProviderActions {
  setConnectors: (connectors: string[]) => void;
  setAlgoSignerLedger: (algoSignerLedger: string) => void;
}

export const foundryProviderState: FoundryProviderState = {
  connectors: [],
  algoSignerLedger: "TestNet",
};
